import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ErrorLabel } from '../models/error-label.model';
import { Utils } from '../shared/utils';
import { Store } from '@ngxs/store';
import { LoadLabels } from 'src/app/store-ngxs/actions/labels.actions';
import { LabelState } from 'src/app/store-ngxs/states/labels.state';

@Injectable({ providedIn: 'root' })
export class TranslationService {
  private dictionary: { [key: string]: string } = {};
  currentLanguage: any = '';
  currentLanguageChanged = new BehaviorSubject(this.currentLanguage);

  constructor(private store: Store) {}

  setCurrentLanguage(lang: any): void {
    this.store.dispatch(new LoadLabels(lang.code));
    this.currentLanguage = lang;
    this.currentLanguageChanged.next(lang);
  }

  setLanguageDictionary(): void {
    this.store.select(LabelState.getLabels).subscribe((labels) => {
      labels?.forEach((label) => {
        this.dictionary[label.labelName] = label.labelValue;
      });
    });
  }

  subscribeForLanguagesAsync(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.store.select(LabelState.getLabels).subscribe((labels) => {
        labels?.forEach((label) => {
          this.dictionary[label.labelName] = label.labelValue;
        });
        if (labels && labels.length > 0) {
          resolve(labels);
        }
      });
    });
  }

  translate(key: string, args?: any): string {
    var translated = this.dictionary[key] ?? key;
    if (args?.length > 0) {
      translated = Utils.formatString(
        translated,
        args
      );
    }
    return translated;
  }

  translateErrorLabel(errorLabel: ErrorLabel): string {
    var translatedValue =
      this.dictionary[errorLabel.LabelKey] ?? errorLabel.LabelKey;
    if (errorLabel.Arguments && errorLabel.Arguments.length > 0) {
      translatedValue = Utils.formatString(
        translatedValue,
        errorLabel.Arguments
      );
    }
    return translatedValue;
  }
}
